import { api } from './_apiInterface';
import { pointer } from 'src/app-config';
import { typeTelephonicTerritory, typeTerritoryNumber, typeUser } from '@monorepo/models';

class TelephonicServices {
    private Base = pointer.telephonic;
    //
    AssignTerritory = async (user: typeUser, toAssign: number | null, toUnassign: number | null, all: boolean | null) => {
        const data = await api.SendRequest(`${this.Base}/assignment`, 'PUT', { all, user, toAssign, toUnassign });
        return data;
    }
    ChangeStateOfTerritory = async (territoryNumber: string, isFinished: boolean) => {
        const data = await api.SendRequest(this.Base, 'PATCH', { territoryNumber, isFinished });
        return data;
    }
    GetGlobalStatistics = async () => {
        const data = await api.SendRequest<{ territoriesTableData: typeTelephonicTerritory[]; }>(`${this.Base}/statistics/table`, 'GET');
        return data;
    }
    GetTerritory = async (territoryNumber: string) => {
        const data = await api.SendRequest<{ telephonicTerritory: typeTelephonicTerritory; }>(`${this.Base}/${territoryNumber}`, 'GET');
        return data;
    }
    ModifyHousehold = async (territoryNumber: typeTerritoryNumber, householdId: number, callingState: string, notSubscribed: boolean, isAssigned: boolean) => {
        const data = await api.SendRequest(`${this.Base}/${territoryNumber}`, 'PUT', { householdId, callingState, notSubscribed, isAssigned });
        return data;
    }
    ResetTerritory = async (territoryNumber: string, option: number) => {
        const data = await api.SendRequest(this.Base, 'DELETE', { territoryNumber, option });
        return data;
    }
}

export const telephonicServices = new TelephonicServices();
